import {createContext, useContext} from 'react';

export interface ProductReviewTranslations {
  sizeRatings: string[];
  qualityRatings: string[];
  ratingTitle: string;
  starRatingTitle: string;
  sizeRatingTitle: string;
  qualityRatingTitle: string;
  recommendTitle: string;
  selectLabel: string;
  displayNameLabel: string;
  reviewTitle: string;
  reviewText: string;
  yesLabel: string;
  noLabel: string;
  submitButtonText: string;
  successModalTitle: string;
  successModalDescription: string;
  errorModalTitle: string;
  errorModalDescription: string;
  alreadyVotedTitle: string;
  alreadyVotedDescription: string;
  errorMessages: {
    minLength: (minChar: number) => string;
    maxLength: (maxChar: number) => string;
    required: string;
  };
}

const translationsContext = createContext<ProductReviewTranslations | null>(
  null,
);

export const useProductReviewTranslations = () => {
  const context = useContext(translationsContext);
  if (context == null) {
    throw 'Rating Translations Context not found! Did you forget to provide the translations?';
  }

  return context;
};

export default translationsContext.Provider;
